const ICE_SERVERS: RTCIceServer[] = [{ urls: "stun:stun.cloudflare.com:3478" }];

const PEER_CONFIG: RTCConfiguration = {
  iceServers: ICE_SERVERS,
  bundlePolicy: "max-bundle",
};

/** Broadcaster-side RTCPeerConnection (Studio ingest). */
export function createBroadcasterConnection(): RTCPeerConnection {
  return new RTCPeerConnection(PEER_CONFIG);
}

/** Listener-side RTCPeerConnection (Tuner egress). */
export function createListenerConnection(): RTCPeerConnection {
  return new RTCPeerConnection(PEER_CONFIG);
}
